export default __webpack_public_path__ + "static/media/my-img.52330fe5.png";